import React from "react";
import { Tag } from "antd";
import { CrownOutlined } from "@ant-design/icons";
import "./VipBadge.styles.scss";

interface VipBadgeProps {
    vipTier?: {
        id: number;
        name: string;
        level: number;
        discountPercent: number;
        color?: string;
    } | null;
    showLevel?: boolean;
    showDiscount?: boolean;
    size?: "small" | "default" | "large";
}

const VipBadge: React.FC<VipBadgeProps> = ({
    vipTier,
    showLevel = true,
    showDiscount = false,
    size = "default"
}) => {
    if (!vipTier) {
        return (
            <Tag 
                color="default" 
                className={`vip-badge vip-badge-${size} vip-badge-none`}
            >
                Chưa có VIP
            </Tag>
        );
    }

    const badgeColor = vipTier.color || "#faad14";
    const levelText = showLevel ? ` (Lv.${vipTier.level})` : "";
    const discountText = showDiscount ? ` - ${vipTier.discountPercent}%` : "";

    return (
        <Tag 
            icon={<CrownOutlined />} 
            color={badgeColor}
            className={`vip-badge vip-badge-${size} vip-badge-active`}
            style={{ 
                backgroundColor: badgeColor,
                borderColor: badgeColor,
                color: getContrastColor(badgeColor)
            }}
        >
            {vipTier.name}{levelText}{discountText}
        </Tag>
    );
};

// Helper function to determine text color based on background color
const getContrastColor = (hexColor: string): string => {
    // Remove # if present
    const hex = hexColor.replace('#', '');
    
    // Convert to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return black for light colors, white for dark colors
    return luminance > 0.5 ? '#000000' : '#ffffff';
};

export default VipBadge;
